
import {
  computed,
  defineComponent,
  onMounted,
  onBeforeUnmount,
  reactive,
  ref,
  ComputedRef,
} from 'vue';
import { useStore } from 'vuex';
import Expand from '@/components/Expand.vue';

export default defineComponent({
  components: {
    Expand,
  },

  props: {
    partnerIds: {
      type: String,
      required: true,
    },
    headline: {
      type: String,
      required: true,
    },
  },

  setup(props) {
    const root = ref<InstanceType<typeof HTMLElement>>();
    const store = useStore();
    const partnerIds = props.partnerIds.split(',').map(($id: string) => parseInt($id, 10));
    const partners = reactive([] as ComputedRef[]);

    partnerIds.forEach(($id: number) => {
      partners.push(computed(() => store.getters['partners/partner']($id)));
    });

    const partnersFiltered = computed(() => partners.filter(
      ($partner) => $partner.value !== null,
    ));

    const sizeClasses = reactive({ value: [] as string[] });

    const setSizeClass = () => {
      sizeClasses.value = [];

      if (root.value) {
        const elementWidth = root.value.scrollWidth;
        if (elementWidth >= 680) {
          sizeClasses.value.push('wide');
        }
      }
    };

    const classes = computed(() => {
      const cls = [...sizeClasses.value];

      return cls;
    });

    onMounted(() => {
      window.addEventListener('resize', setSizeClass);
      window.addEventListener('load', setSizeClass);
      setSizeClass();
    });

    onBeforeUnmount(() => {
      window.removeEventListener('resize', setSizeClass);
      window.removeEventListener('load', setSizeClass);
    });

    const getPhoneRef = (phonenumber: string) => {
      let phonenumberFormatted = phonenumber;

      if (phonenumberFormatted.startsWith('0')) {
        phonenumberFormatted = `+49${phonenumberFormatted.substr(1)}`;
      }

      return `tel:${phonenumberFormatted.replace(' ', '')}`;
    };

    return {
      root,
      store,
      sizeClasses,
      classes,
      getPhoneRef,
      partners,
      partnersFiltered,
    };
  },
});
